import { render, staticRenderFns } from "./NewsletterWidget.vue?vue&type=template&id=0b495b30"
import script from "./NewsletterWidget.vue?vue&type=script&lang=ts"
export * from "./NewsletterWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports